module.exports = __webpack_public_path__ + "img/dice-d4.2d11e7a3.svg";